module.exports = __webpack_public_path__ + "static/media/apple-logo.4aa5ad47.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/custom-products/iphone/apple-logo.png
// module id = 399
// module chunks = 0